import { gql } from '@apollo/client';

export const fetchInvoicesForTransactionAccountPPC = gql`
  query fetchInvoicesForTransactionAccountPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: InvoicesFilterOptions
  ) {
    transactionAccount(id: $id) {
      id
      pendingInvoices
      invoices(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          billingGroupId
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          creditCard {
            last4Numbers
          }
          invoiceDueDays
          paymentMethod
          dueDate
          prePaymentCreditNotesAmount
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          pricingCurrency
          pdfLink
          transactionAccountId
          refunds {
            id
            type
            createdDate
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
            creditNoteId
          }
          status
          dunningStatus {
            errorCode
            nextPaymentAttempDate
          }
          shipTo {
            id
            fullName
            address {
              address1
              address2
              city
              state
              country
              postalCode
            }
          }
          purchaseOrderNumber
          paypalAccountEmail
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          type
          paymentIssue
          default
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
              payOnStatement
            }
          }
          ... on PayPal {
            payPal {
              email
              name
            }
          }
          ... on Ach {
            ach {
              bankName
              last4
            }
          }
        }
      }
    }
  }
`;
